import { useCallback, useEffect, useRef } from "react";
import { AxiosResponse } from "axios";
import { toast } from "react-toastify";

type UseSessionPingProps = {
  readonly apiPing?: () => Promise<AxiosResponse<any> | undefined>;
};

export const useSessionPing = ({ apiPing }: UseSessionPingProps) => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const isFirstRender = useRef(true); // Отслеживаем первый рендер

  const sendPing = useCallback(async () => {
    if (!apiPing) return;

    try {
      await apiPing();
    } catch (error: any) {
      //toast.error(`Ping failed. Error: ${error.message || error.toString()}`);
      console.log(`Ping failed. Error: ${error.message || error.toString()}`);
    }
  }, [apiPing]);

  useEffect(() => {
    // Отправляем пинг только при первом рендере
    if (isFirstRender.current) {
      sendPing();
      isFirstRender.current = false; // Больше не первый рендер
    }

    // Устанавливаем таймер для отправки пингов каждые 5 минут
    timerRef.current = setInterval(() => {
      sendPing();
    }, 5 * 60 * 1000); // 5 минут

    // Возвращаем функцию для очистки таймера при размонтировании компонента
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [sendPing]); // Зависимость только от sendPing
};

